import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Cart from '../components/Cart';
import { color, animation } from '../styles/helpers/variables';

class CartWrapperCheckoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCartOpened: true
    };
  }

  render() {
    return (
      <div>
        <CartWrapperCheckoutPageContainer>
          <ToggleButton>
            Min varukorg (<span>{this.props.totalCartItems}</span>)
          </ToggleButton>
          <Icon
            active={this.state.isCartOpened}
            onClick={() => {
              this.setState({ isCartOpened: !this.state.isCartOpened });
            }}
          />
        </CartWrapperCheckoutPageContainer>
        {this.state.isCartOpened ? <Cart onCheckoutPage onMobile /> : false}
      </div>
    );
  }
}

const CartWrapperCheckoutPageContainer = styled.div`
  padding: 3px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleButton = styled.p`
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${color.black};

  span {
    color: ${color.primary};
    font-weight: 600;
  }
`;

const Icon = styled.button`
  background-color: transparent;
  outline: 0;
  border: none;
  width: 14px;
  height: 44px;
  background-image: url('/images/icons/close.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px;
  cursor: pointer;
  opacity: 1;
  transform: rotateZ(-45deg);
  transition: opacity ${animation.transitionTime} ${animation.easing},
    transform ${animation.transitionTime} ${animation.easing};

  &:hover {
    opacity: 0.8;
  }

  ${props =>
    props.active &&
    css`
      transform: rotateZ(0);
    `};
`;

CartWrapperCheckoutPage.propTypes = {
  totalCartItems: PropTypes.number.isRequired
};

export default CartWrapperCheckoutPage;



// WEBPACK FOOTER //
// ./src/components/CartWrapperCheckoutPage.js